import { CustomIconType } from './getCustomCompletePageIcons'

export const getIconFromCustomCompletePage = (
  value?: string | null
): CustomIconType | undefined => {
  if (!value || value === 'default') return 'check' as CustomIconType
  const match = value.match(/@icon\[(.*?)\]/)
  return match?.[1] as CustomIconType | undefined
}
